import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { EmailAddressInput } from '@dreryk/react-components';

type EmailAddressFieldProps = Pick<FormContextValues, 'register'>;

const EmailAddressField = (props: EmailAddressFieldProps): JSX.Element => {
   return (
      <EmailAddressInput
         controller={props.register('emailAddress')}
         label={commonTranslationKeys.email}
         testId={'email'}
      />
   );
};

export { EmailAddressField };
